import axios from '../utils/axios';

export default function addFollowupCredit(adminId, body) {
    return axios.post(`/admin/${adminId}/jobseeker-admin/v2/admin-recruiter/followup`, body);
}